import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { installGlobalErrorLogging } from '@/utils/global-error-logging';
import { installReloadOnStaleChunk } from '@/utils/reload-on-stale-chunk';

installGlobalErrorLogging();
installReloadOnStaleChunk();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
